import { computed } from '@vue/composition-api'
import i18n from '@/libs/i18n'

// Resolve the declaration "type" from the current route path.
// The three logical modules (Lobby, Conflict of Interest Collaborator/Supplier)
// share this single set of components and are differentiated at runtime.
export const getDeclarationType = path => {
  if (!path) return 'lobby'
  if (path.includes('conflict-of-interest-collaborator')) return 'collaborator'
  if (path.includes('conflict-of-interest-supplier')) return 'supplier'
  return 'lobby'
}

// Tipo de Documento options per type
export const tipoOptions = computed(() => ({
  lobby: [
    { value: 'gifts', title: i18n.t('declaration.tipo_gifts') },
    { value: 'externalActivities', title: i18n.t('declaration.tipo_externalActivities') },
    { value: 'supplierRelation', title: i18n.t('declaration.tipo_supplierRelation') },
    { value: 'publicOfficialMeeting', title: i18n.t('declaration.tipo_publicOfficialMeeting') },
  ],
  collaborator: [
    { value: 'conflictOfInterest', title: i18n.t('declaration.tipo_conflictOfInterest') },
  ],
  supplier: [
    { value: 'conflictOfInterest', title: i18n.t('declaration.tipo_conflictOfInterest') },
  ],
}))

// Temática options (only used by Conflict of Interest types; Lobby uses free text)
export const tematicaOptions = computed(() => [
  { value: 'declaracionInicial', title: i18n.t('declaration.tematica_declaracionInicial') },
  { value: 'actualizacionDeclaracion', title: i18n.t('declaration.tematica_actualizacionDeclaracion') },
])

// Per-type configuration driving fields, labels, routing and behaviour.
export const DECLARATION_CONFIG = {
  lobby: {
    type: 'lobby',
    moduleKey: 'records-lobby',
    routeName: 'organization-lobby',
    routePath: '/organization/lobby',
    s3Folder: 'lobby',
    // Main entity field ("name"-like column)
    mainField: 'trabajador',
    mainFieldKind: 'worker',
    mainFieldLabel: 'declaration.colaborador',
    mainFieldPlaceholder: 'declaration.placeholder_colaborador',
    showInstitucion: true,
    showFechaReunion: true,
    tematicaFreeText: true,
  },
  collaborator: {
    type: 'collaborator',
    moduleKey: 'records-coi-collaborator',
    routeName: 'organization-conflict-of-interest-collaborator',
    routePath: '/organization/conflict-of-interest-collaborator',
    s3Folder: 'conflict-of-interest-collaborator',
    mainField: 'trabajador',
    mainFieldKind: 'worker',
    mainFieldLabel: 'declaration.colaborador',
    mainFieldPlaceholder: 'declaration.placeholder_colaborador',
    showInstitucion: false,
    showFechaReunion: false,
    tematicaFreeText: false,
  },
  supplier: {
    type: 'supplier',
    moduleKey: 'records-coi-supplier',
    routeName: 'organization-conflict-of-interest-supplier',
    routePath: '/organization/conflict-of-interest-supplier',
    s3Folder: 'conflict-of-interest-supplier',
    mainField: 'proveedor',
    mainFieldKind: 'text',
    mainFieldLabel: 'declaration.proveedor',
    mainFieldPlaceholder: 'declaration.placeholder_proveedor',
    showInstitucion: false,
    showFechaReunion: false,
    tematicaFreeText: false,
  },
}

export const getDeclarationConfig = path => DECLARATION_CONFIG[getDeclarationType(path)]
